<template lang="html">
  <div>
    <v-dialog
      v-model="DetailNoteChatDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
      <!-- start -->
      <div v-if="status_edit === 'start'" class="pa-1">
        <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
          <v-col
            cols="2"
            justify="center"
            align="start"
            class="pr-0 pt-0 pb-0 cursor"
            @click="close()"
          >
            <v-icon class="fz-30">mdi-chevron-left</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('Dialog.note.headerNote')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            v-if="status_note === 'active'"
            >
            <v-icon class="fz-20" @click="openDialog(NoteDetail, 0, 'list-note')">fa-solid fa-list</v-icon>
            <v-icon v-if="detail_note.owner === data_user.tokenuser" class="fz-20 ml-3" @click="openDialog(NoteDetail, 0, 'edit')">mdi-dots-vertical</v-icon>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-2 pl-0 pt-0 pb-0"
            v-else
            >
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout v-if="status_note === 'active'" row wrap justify-start align-start class="mt-3 pl-5 pr-5 pb-5">
          <v-col cols="2">
            <v-avatar>
              <img v-if="detail_note.profilepicture" :src="detail_note.profilepicture" :alt="detail_note.nickname" class="img-position">
              <img v-else-if="detail_note.type === 'business'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" class="img-position" :alt="detail_note.nickname">
              <img v-else-if="detail_note.type === 'government'" :src="`${publicPath}/assets/img/default_profile/business-white.png`" class="img-position" :alt="detail_note.nickname">
              <img v-else-if="detail_note.type === 'bot'" :src="`${publicPath}/assets/img/default_profile/bot-white.png`" class="img-position" :alt="detail_note.nickname">
              <img v-else :src="`${publicPath}/assets/img/default_profile/man-white.png`" class="img-position" :alt="detail_note.nickname">
            </v-avatar>
          </v-col>
          <v-col cols="10">
            <b class="text-overflow pl-2">{{detail_note.nickname}}</b>
            <br>
            <span class="text-overflow pl-2 tab-title-status">{{date(detail_note.create_date)}} {{time(detail_note.create_date)}}</span>
          </v-col>
          <v-col
            cols="12"
          >
            <v-textarea
              v-model="data_note"
              filled
              name="input-7-4"
              clearable
              solo
              clear-icon="mdi-close-circle"
              :placeholder="$t('ChatSide.textarea.normal')"
              hide-details
              no-resize
              :disabled="status_edit === 'start'"
            ></v-textarea>
          </v-col>
        </v-layout>
        <v-layout v-else column wrap justify-center align-center class="mt-3 pl-5 pr-5 pb-5 height-80">
          <v-icon class="fz-80">fa-solid fa-note-sticky</v-icon>
          <h3 class="mt-3">{{$t('Dialog.note.noNote')}}</h3>
        </v-layout>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/>
    <EditNoteChat :NoteDetail="EditNoteDetail" :EditNoteChatDialog="EditNoteChatDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
    <!-- <NoteChat :NoteChatDialog="NoteChatDialog" :NoteChatDetail="NoteChatDetail" @closeComponents="closeComponents"/> -->
  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import ListBottomMenu from '@/components/Alert/ListBottomMenu'
import EditNoteChat from '@/components/EditNoteChat'
// import NoteChat from '@/components/NoteChat'
var _ = require('lodash')
export default {
  props: {
    DetailNoteChatDialog: Boolean,
    NoteDetail: {}
  },
  data () {
    return {
      status_note: 'active',
      NoteChatDetail: {},
      NoteChatDialog: false,
      publicPath: process.env.VUE_APP_BASE_PATH,
      EditNoteDetail: {},
      EditNoteChatDialog: false,
      data_note_edit: '',
      detail_note: {},
      data_note: '',
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_note: [],
      status_edit: 'start',
      progress: false,
      data_user: {},
      stylechat: {
        "--NoteChat-HeaderColor": "white",
        "--NoteChat-TabBackground": "white",
        "--NoteChat-Icon": "gray",
        "--NoteChat-IconActive": "#2662ae",
        "--NoteChat-Background": "white",
        "--NoteChat-FontSize": "18px",
        "--NoteChat-FontSize-Title": "24px",
        "--NoteChat-FontColor": "back",
        "--NoteChat-FontSize-Status": "16px",
        "--NoteChat-FontColor-Status": "grey",
        "--NoteChat-Background-Input": "#E2E1E3",
        "--NoteChat-Color-Button": "#EFF2FE",
        "--NoteChat-FontColor-Button": "#2662ae",
        "--NoteChat-FontColor-Block-Button": "#cb1002",
        "--NoteChat-FontColor-Dis-Button": "#e2e1e3",
        "--NoteChat-Btn-Confirm-Background": "#2662ae",
        "--NoteChat-Btn-Confirm-Color": "white",
        "--NoteChat-Btn-Confirm-FontSize": "18px",
        "--NoteChat-Btn-Cancel-Background": "white",
        "--NoteChat-Btn-Cancel-Color": "#2662ae",
        "--NoteChat-Btn-Cancel-FontSize": "18px",
        "--NoteChat-Btn-Leave-Background": "white",
        "--NoteChat-Btn-Leave-Color": "#ff5252",
        "--NoteChat-Btn-Leave-FontSize": "18px",
        "--NoteChat-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
    ListBottomMenu,
    EditNoteChat,
    // NoteChat
  },
  watch: {
    DetailNoteChatDialog () {
      if (this.DetailNoteChatDialog) {
        // console.log(this.NoteDetail)
        this.getNote()
      }
    }
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
  },
  methods: {
    emitComponents (value) {
      if (value.name === 'detail-note') {
        this.DetailNoteChatDialog = false
        this.getNote()
      } else if (value.name === 'edit-note') {
        this.EditNoteChatDialog = false
        this.getNote()
      }
    },
    closeComponents (data) {
      // console.log(data)
      if (data.name === 'edit-note') {
        this.EditNoteChatDialog = data.value
      } else if (data.name === 'detail-note') {
        this.DetailNoteChatDialog = data.value
      } else if (data.name === 'notechat') {
        this.NoteChatDialog = data.value
      }
    },
    getNote () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/getnote`, {
        note_id: this.NoteDetail.note_id,
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          if (response.data.list_note.length !== 0) {
            this.status_note = 'active'
            this.detail_note = response.data.list_note[0]
            this.data_note_edit = response.data.list_note[0].note_data.text
            this.data_note = response.data.list_note[0].note_data.text
          } else {
            this.status_note = 'delete'
            // console.log(this.status_note)
          }
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    editNote () {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/editnote`, {
        text: this.data_note,
        tokenuser: this.data_user.tokenuser,
        note_id: this.NoteDetail.note_id
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.data_note = ''
          this.$emit('emitComponents', { name: 'detail-note', value: false })
        } else {
          this.data_note = ''
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.data_note = ''
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    emitListBottom (value) {
      // console.log(value)
      this.ListBottomMenu = false
      if (value.item.actions === 'delete-note') {
        this.openDialog(value.item, value.item.index, 'delete-note')
      } else if (value.item.actions === 'detail-note') {
        this.EditNoteDetail = value.item.item
        this.EditNoteChatDialog = true
      }
    },
    openDialog (item, index, type) {
      if (type === 'create') {
        // console.log('create');
      } else if (type === 'edit') {
        this.ListBottomItem = [
          {
            text: this.$t('AnswerQuestion.edit'),
            icon: 'fa-solid fa-pen-to-square',
            actions: 'detail-note',
            id: item.note_id,
            index: index,
            item: item
          },
          {
            text: this.$t('AnswerQuestion.remove'),
            icon: 'fa-solid fa-trash-can',
            actions: 'delete-note',
            id: item.note_id,
            index: index
          }
        ]
        this.ListBottomMenu = true
      } else if (type === 'delete-note') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Dialog.note.deleteNote'),
          detail: item,
          index: index,
          type: 'delete-note'
        }
        this.WarningDialog = true
      } else if (type === 'list-note') {
        if (this.NoteDetail.previous === 'list-note') {
          // กรณีกดมาจากหน้าโน้ต
          this.$emit('emitComponents', { name: 'detail-note', value: false })
        } else {
          // กรณีกดมาจากหน้าแชท
          if (this.NoteDetail.previous === 'chat-room') {
            this.$emit('emitComponents', { name: 'list-note', value: false, item: item })
            // this.NoteChatDetail = item
            // var me = this
            // setTimeout(function() {
            //   me.NoteChatDialog = true
            // }, 1000);
          }
        }
      }
    },
    date (timestamp) {
      return Momenttime.dayjsdatethai(timestamp)
    },
    time (timestamp) {
      return Momenttime.dayjstimethai(timestamp)
    },
    close () {
      this.data_note = ''
      this.$emit('closeComponents', {
        name: 'detail-note',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'delete-note') {
        this.deleteNote(item.detail.id, item.index)
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    deleteNote (id, index) {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/removenote`, {
        note_id: id,
        tokenuser: this.data_user.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.$emit('emitComponents', { name: 'detail-note', value: false })
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
  }
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer;
}
.height-100 {
  height: 100vh;
}
.height-80 {
  height: 80vh;
}
.fz-18 {
  font-size: 18px !important;
}
.fz-20 {
  font-size: 20px !important;
}
.fz-60 {
  font-size: 60px !important;
}
.fz-80 {
  font-size: 80px !important;
}
.text-btn {
  color: var(--NoteChat-FontColor-Button) !important
}
.text-btn-disable {
  color: var(--NoteChat-FontColor-Dis-Button) !important
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.font-list-title {
  font-weight: 600;
  color: var(--NoteChat-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--NoteChat-FontSize-Title) !important;
  color: var(--NoteChat-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--NoteChat-FontSize-Title-Edit) !important;
  color: var(--NoteChat-FontColor) !important;
}
.tab-title {
  color: var(--NoteChat-FontColor) !important;
  font-size: var(--NoteChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--NoteChat-FontColor-Status) !important;
  font-size: var(--NoteChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
.checkbox-color {
  color: var(--NoteChat-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--NoteChat-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--NoteChat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--NoteChat-Icon) !important;
}
.icon-color {
  color: var(--NoteChat-IconActive) !important;
}
.btn-confirm {
  background-color: var(--NoteChat-Btn-Confirm-Background) !important;
  color: var(--NoteChat-Btn-Confirm-Color) !important;
  font-size: var(--NoteChat-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--NoteChat-Btn-Cancel-Background) !important;
  color: var(--NoteChat-Btn-Cancel-Color) !important;
  font-size: var(--NoteChat-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--NoteChat-Btn-Leave-Background) !important;
  color: var(--NoteChat-Btn-Leave-Color) !important;
  font-size: var(--NoteChat-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--NoteChat-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--NoteChat-FontSize-Title) !important;
  color: var(--NoteChat-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--NoteChat-FontColor) !important;
  font-size: var(--NoteChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--NoteChat-FontColor-Status) !important;
  font-size: var(--NoteChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
